import { __makeTemplateObject } from "tslib";
import { Button, FormControl, Typography, createStyles, makeStyles } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import styled from "styled-components";
import * as colors from "../colors";
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        deleteIcon: {
            background: "transparent"
        },
        modal: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        card: {
            borderRadius: "5px"
        },
        title: {
            fontSize: theme.typography.pxToRem(25),
            fontWeight: 900
        },
        closeIcon: {
            marginTop: "-15px",
            marginRight: "-15px"
        },
        subTitle: {
            color: colors.basic[400],
            marginBottom: "15px"
        },
        modalFooter: {
            paddingTop: "25px"
        },
        cancelBtn: {
            fontSize: theme.typography.pxToRem(16),
            backgroundColor: "transparent",
            color: colors.basic[400],
            borderColor: colors.basic[600],
            borderWidth: "1px",
            borderStyle: "solid",
            marginRight: "10px",
            padding: "8px 20px"
        },
        deleteBtn: {
            fontSize: theme.typography.pxToRem(16),
            backgroundColor: theme.palette.lightButtonColors.danger.backgroundColor,
            color: theme.palette.lightButtonColors.danger.color,
            padding: "8px 20px"
        },
        deleteAllBtn: {
            backgroundColor: theme.palette.lightButtonColors.danger.backgroundColor,
            color: theme.palette.lightButtonColors.danger.color,
            marginRight: "10px",
            fontSize: theme.typography.pxToRem(15),
            padding: "15px 6px 15px 6px",
            lineHeight: 1.2
        },
        deleteLessonOnlyBtn: {
            backgroundColor: theme.palette.lightButtonColors.danger.backgroundColor,
            color: theme.palette.lightButtonColors.danger.color,
            fontSize: theme.typography.pxToRem(15),
            padding: "15px 6px 15px 6px",
            lineHeight: 1.2
        },
        selectFilled: {
            backgroundColor: theme.palette.frame.contentBackgroundColor,
            borderRadius: "4px"
        },
        save: {
            marginLeft: "10px"
        }
    });
});
export var LabelText = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: hsla(0, 0%, 100%, 0.38);\n\tmargin-bottom: 10px;\n"], ["\n\tcolor: hsla(0, 0%, 100%, 0.38);\n\tmargin-bottom: 10px;\n"])));
export var FormControlContainer = styled(FormControl)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"])));
export var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-right: 1.3rem;\n\n\t.breadcrum-container {\n\t\tmargin-top: 6px;\n\n\t\tdiv {\n\t\t\tfont-size: 13px;\n\t\t\tline-height: 1.23;\n\t\t\tcolor: ", ";\n\t\t}\n\n\t\tdiv:last-child {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"], ["\n\tmargin-right: 1.3rem;\n\n\t.breadcrum-container {\n\t\tmargin-top: 6px;\n\n\t\tdiv {\n\t\t\tfont-size: 13px;\n\t\t\tline-height: 1.23;\n\t\t\tcolor: ", ";\n\t\t}\n\n\t\tdiv:last-child {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.colors.basic[400];
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.colors.basic[100];
});
export var BasicButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tfont-weight: 800;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tfont-weight: 800;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.lightButtonColors.basic.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.lightButtonColors.basic.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return alpha(theme.palette.colors.basic[400], 0.4);
});
export var PrimaryAlphaButton = styled(Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tcolor: ", ";\n\tbackground-color: ", ";\n\t&:hover {\n\t\tbackground-color: ", "60;\n\t}\n"], ["\n\tcolor: ", ";\n\tbackground-color: ", ";\n\t&:hover {\n\t\tbackground-color: ", "60;\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.primary.main;
}, function (_a) {
    var theme = _a.theme;
    return alpha(theme.palette.primary.main, 0.6);
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.colors.primary[500];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map